import { useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import AnimatedSection from "@/components/AnimatedSection";

const WhyChooseUs = lazy(() => import("@/components/WhyChooseUs"));
const ServiceAreas = lazy(() => import("@/components/ServiceAreas"));
const BeforeAfter = lazy(() => import("@/components/BeforeAfter"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Pricing = lazy(() => import("@/components/Pricing"));
const ContactForm = lazy(() => import("@/components/ContactForm"));
const Footer = lazy(() => import("@/components/Footer"));
const CookieConsent = lazy(() => import("@/components/CookieConsent"));
const FloatingContact = lazy(() => import("@/components/FloatingContact"));

const Index = () => {
  const location = useLocation();
  useEffect(() => {
    const state = location.state as { scrollTo?: string } | null;
    if (state?.scrollTo) {
      // Wait a tick for sections to render
      setTimeout(() => {
        const el = document.getElementById(state.scrollTo!);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [location.state]);

  // JSON-LD complet (LocalBusiness, Reviews, Services, Offers, etc.)
  // est déjà injecté en statique dans index.html — on ne duplique pas ici.
  return (
    <main className="min-h-screen">
      <Header />
      <Hero />
      <AnimatedSection animation="fade-up">
        <Services />
      </AnimatedSection>
      <Suspense fallback={null}>
        <AnimatedSection animation="fade-up" delay={100} className="content-visibility-auto">
          <Pricing />
        </AnimatedSection>
        <AnimatedSection animation="fade-up" className="content-visibility-auto">
          <ServiceAreas />
        </AnimatedSection>
        <AnimatedSection animation="fade-up" className="content-visibility-auto">
          <ContactForm />
        </AnimatedSection>
        <AnimatedSection animation="fade-up" delay={100} className="content-visibility-auto">
          <WhyChooseUs />
        </AnimatedSection>
        <AnimatedSection animation="fade-up" delay={100} className="content-visibility-auto">
          <BeforeAfter />
        </AnimatedSection>
        <AnimatedSection animation="fade-up" className="content-visibility-auto">
          <Testimonials />
        </AnimatedSection>
        <Footer />
        <CookieConsent />
        <FloatingContact />
      </Suspense>
    </main>
  );
};

export default Index;
